import { defineMessages } from 'react-intl';

const enumMessages = defineMessages({
    PENDING: {
        id: 'loanStatus.PENDING',
        defaultMessage: 'Pending',
    },
    PROCESSING: {
        id: 'loanStatus.PROCESSING',
        defaultMessage: 'Processing',
    },
    BOOKED: {
        id: 'loanStatus.BOOKED',
        defaultMessage: 'Booked',
    },
    ACTIVE: {
        id: 'loanStatus.ACTIVE',
        defaultMessage: 'Active',
    },
    SETTLED: {
        id: 'loanStatus.SETTLED',
        defaultMessage: 'Past due',
    },
    CANCELED: {
        id: 'loanStatus.CANCELED',
        defaultMessage: 'Cancelled',
    },
    RENEGOTIATED: {
        id: 'loanStatus.RENEGOTIATED',
        defaultMessage: 'Renegotiated',
    },
    WRITTEN_OFF: {
        id: 'loanStatus.WRITTEN_OFF',
        defaultMessage: 'Written off',
    },
});

export default enumMessages;
